import { Input, Select } from "antd"
import React, { useRef } from "react"
import SvgIcon from "src/components/SvgIcon"
import { InputSearchStyle } from "src/pages/ADMIN/HumanResource/styled"
import SelectLocalRoaming from "src/components/Dropdown/SelectLocalRoaming"
import SelectSimType from "src/components/Dropdown/SelectSimType"
import SelectPackageCycle from "src/components/Dropdown/SelectPackageCycle"
import PublicSelectCountry from "src/pages/STAFF/PublicDropdown/PublicSelectCountry"

const CheckPackage = ({ setFilter, setKeyword }) => {
  const inputSearchRef = useRef()
  const onSearch = () => {
    const keyword = inputSearchRef.current || ""
    setKeyword(keyword)
  }
  const onClearSearch = () => {
    inputSearchRef.current = ""
    setKeyword("")
  }
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 16,
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          maxWidth: "1000px",
        }}
      >
        <PublicSelectCountry
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, country_id: val }))}
          type={null}
        />
        <SelectPackageCycle
          placeholder="Chọn chu kỳ gói cước"
          onChange={val => setFilter(prev => ({ ...prev, date: val }))}
          style={{ width: 150 }}
        />
        {/* <PublicSelectNetWork
          style={{ width: 150 }}
          onChange={val =>
            setFilter(prev => ({ ...prev, network_carrier_id: val }))
          }
        /> */}
        {/* <SelectLocalRoaming
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, service_type: val }))}
        />
        <SelectSimType
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, sim_type: val }))}
        /> */}
      </div>
      {/* <div>
        <InputSearchStyle>
          <Input
            className="custom-input"
            maxLength={50}
            placeholder="Tìm kiếm theo tên gói cước"
            onChange={e => (inputSearchRef.current = e.currentTarget.value)}
            onPressEnter={onSearch}
            onClear={onClearSearch}
            size="small"
            allowClear
          />
          <div className="custom-icon-search">
            <SvgIcon name="searchStatistic" />
          </div>
        </InputSearchStyle>
      </div> */}
    </div>
  )
}
export default CheckPackage
